import React, { createContext, useContext, useState } from 'react';

type SideBarContextType = {
    sidebarStatus: boolean,
    setSidebarStatus: (value: boolean) => void;
  }

const sideBarContext = createContext<SideBarContextType | undefined>(undefined)

type PropTypes = {
    children: React.ReactNode
};
export const SideBarStatusProvider = ({children}: PropTypes) => {

    const [sidebarStatus, setSidebarStatus] = useState(false)

    return (
        <sideBarContext.Provider value={{sidebarStatus, setSidebarStatus}}>
            {children}
        </sideBarContext.Provider>
      )
}

export function useSideBarStatus() {
    const context = useContext(sideBarContext);
  
    if (!context) {
        throw new Error('"useSideBarStatus" must be used within IssuesContext')
    }
  
    return context;
  }